import { useState, useCallback, danger, fileTypesExcelOptions } from "@";
import ExcelJS from "exceljs";

// Hook for importing data from Excel files
export const useImportData = (setValue, reset, to = "") => {
  const [previewData, setPreviewData] = useState([]);
  const [previewDataOrderDetails, setPreviewDataOrderDetails] = useState([]);

  const uploadFile = useCallback(
    async (event) => {
      const file = event.target.files[0];

      if (!fileTypesExcelOptions.includes(file.type)) {
        await danger("تنسيق الملف غير مدعوم اختر ملف من النوع xlsx, xls");
        return;
      }
      if (file) {
        setValue("file", file);
        const reader = new FileReader();
        reader.onload = async (event) => {
          const data = new Uint8Array(event.target.result);
          const workbook = new ExcelJS.Workbook();
          await workbook.xlsx.load(data);
          const sheetName = workbook.worksheets[0].name;
          const worksheet = workbook.getWorksheet(sheetName);
          let jsonData = [];
          worksheet.eachRow((row) => {
            const rowData = [];
            row.eachCell((cell) => {
              const value = cell.value;
              rowData.push(
                typeof value === "boolean" ? (value ? 1 : 0) : value || "",
              );
            });
            jsonData.push(rowData);
          });
          setPreviewData(jsonData.slice(0, 3));
        };
        reader.readAsArrayBuffer(file);
      }
    },
    [setValue, setPreviewData],
  );

  const uploadOrderDetailsFile = useCallback(
    async (event) => {
      const file = event.target.files[0];

      if (!fileTypesExcelOptions.includes(file.type)) {
        await danger("تنسيق الملف غير مدعوم اختر ملف من النوع xlsx, xls");
        return;
      }
      if (file) {
        setValue("orderDetailsFile", file);
        const reader = new FileReader();
        reader.onload = async (event) => {
          const data = new Uint8Array(event.target.result);
          const workbook = new ExcelJS.Workbook();
          await workbook.xlsx.load(data);
          const sheetName = workbook.worksheets[0].name;
          const worksheet = workbook.getWorksheet(sheetName);
          let jsonData = [];
          worksheet.eachRow((row) => {
            const rowData = [];
            row.eachCell((cell) => {
              const value = cell.value;
              rowData.push(
                typeof value === "boolean" ? (value ? 1 : 0) : value || "",
              );
            });
            jsonData.push(rowData);
          });
          setPreviewDataOrderDetails(jsonData.slice(0, 3));
        };
        reader.readAsArrayBuffer(file);
      }
    },
    [setValue, setPreviewDataOrderDetails],
  );

  return {
    uploadFile,
    previewData,
    previewDataOrderDetails,
    uploadOrderDetailsFile,
    setPreviewData,
    setPreviewDataOrderDetails,
  };
};
